import { useState } from "react";

const DashboardViewModal = () => {
  const [ChartData, setChartData] = useState({
    options: {
      chart: {
        id: "basic-line",
        type: "line",
        toolbar: {
          tools: {
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
        // set the curve option to 'smooth'
        curve: "smooth",
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      colors: ["#5976E5", "#85CCD6"],
    },
    series: [
      {
        name: "Teachers",
        data: [30, 40, 35, 50, 49, 60, 70, 91, 125, 100, 85, 90],
      },
      {
        name: "Students",
        data: [15, 25, 20, 35, 34, 45, 55, 76, 100, 75, 60, 65],
      },
    ],
  });

  return {
    ChartData,
  };
};

export default DashboardViewModal;
